jQuery(document).ready(function($) {

/* ====================== DISPLAY HEIGHT VARS ======================  */
  if (navigator.userAgent.match(/(iPod|iPhone|iPad)/) && window.innerHeight > window.innerWidth) {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', vh+'px');
      document.documentElement.style.setProperty('--staticvh', vh+"px");
      window.addEventListener('resize', function() {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', vh+'px');
      });
  }

/* ====================== SMOOTH SCROLL HASH LINKS ======================  */
    $('a[href*="#"]').on('click', function(event) {
        var targetId = $(this).attr('href').split('#')[1]; // Get the ID from the href
        var targetElement = $('#' + targetId); // Select the target element

        if (targetElement.length) { // Check if the element exists
            event.preventDefault(); // Prevent default anchor link behavior

            $('html, body').animate({
                scrollTop: targetElement.offset().top
            }, 800, 'swing'); // Smooth scroll animation
        }
    });

/* ====================== SCROLL TO TOP ======================  */
    $('.js-scroll-top').on('click', function() {
        $('html, body').animate({
            scrollTop: 0
        }, 800, 'swing');
    });

/* ====================== ADD CLASS TO EMPTY P TAGS ======================  */
  document.querySelectorAll('p').forEach(p => {
    if (p.innerHTML.trim() === '&nbsp;') {
      p.classList.add('only-nbsp');
    }
  });

/* ====================== INIT FUNCSTIONS ======================  */

/* ====================== WINDOW REISZE FUNCTION  ======================  */
  $(window).resize(function() {
  })
});
